module.exports = __webpack_public_path__ + "static/media/grid_img3.ec064973.jpeg";